"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var useFullScreenDialog = function () {
    var theme = core_1.useTheme();
    // Full screen dialogs will only be used for xs devices.
    return !core_1.useMediaQuery(theme.breakpoints.up('sm'));
};
exports.default = useFullScreenDialog;
